import {
  toMediaTypeString
} from "./chunk-PDD4MAGE.js";

// src/adapter/native/can-play-type.ts
function canPlayType(mediaType) {
  const typeString = toMediaTypeString(mediaType);
  const testElement = document.createElement("video");
  return !!testElement.canPlayType(typeString);
}

export {
  canPlayType
};
